import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { fetchNews } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { FilterBar } from '../components/FilterBar.jsx';
import { NewsGrid } from '../components/NewsGrid.jsx';
import { usePage } from '../hooks/usePage.js';

const CATEGORIES = [
  { id: 'notice', label: 'Notices' },
  { id: 'story', label: 'Stories' },
  { id: 'event', label: 'Events' },
  { id: 'achievement', label: 'Achievements' },
  { id: 'in_memoriam', label: 'In memoriam' },
];

export function NewsListPage() {
  const head = usePage('news');
  const [params, setParams] = useSearchParams();
  const category = params.get('category') || 'all';
  const page = Math.max(1, Number(params.get('page')) || 1);

  const fetchOpts = { page, limit: 12, ...(category !== 'all' ? { category } : {}) };
  const { data, loading } = useApi(() => fetchNews(fetchOpts), [category, page]);

  const items = data?.items || [];
  const total = data?.total || 0;
  const hasMore = data?.hasMore || false;

  const setCategory = (id) => {
    const next = new URLSearchParams(params);
    if (id === 'all') next.delete('category'); else next.set('category', id);
    next.delete('page');
    setParams(next);
  };

  const setPage = (p) => {
    const next = new URLSearchParams(params);
    if (p <= 1) next.delete('page'); else next.set('page', String(p));
    setParams(next);
  };

  useEffect(() => { window.scrollTo({ top: 0 }); }, [page, category]);

  return (
    <>
      <Seo title="News" description={head.metaDescription} />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Media & News' }, { label: 'News' }]}
        headline={head.headline}
        lede={head.lede}
        image={head.banner}
      />

      <section>
        <div className="container">
          <FilterBar options={CATEGORIES} value={category} onChange={setCategory} />

          <div style={{ marginTop: 32 }}>
            <NewsGrid
              items={items}
              columns={3}
              emptyText={loading ? 'Loading…' : 'No articles in this category yet.'}
            />
          </div>

          {(page > 1 || hasMore) && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 48 }}>
              <button className="btn btn-ghost btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Previous</button>
              <span style={{ alignSelf: 'center', color: 'var(--ink-3)', fontSize: 14 }}>
                Page {page} · {total} article{total === 1 ? '' : 's'}
              </span>
              <button className="btn btn-ghost btn-sm" disabled={!hasMore} onClick={() => setPage(page + 1)}>Next →</button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
